import React from 'react';
import { PropsWithChildren } from 'react';

import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';

const PageFooter = ({ children }: PropsWithChildren) => {
  return (
    <Paper elevation={3} sx={{ flexShrink: 0 }}>
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1,
          paddingLeft: 2,
        }}
      >
        {children}
      </Toolbar>
    </Paper>
  );
};

export default PageFooter;
